export enum LoaderTypes {
  main = 'main',
  inner = 'inner',
}
